import { render } from "./FormAbandonConfirmModal.vue?vue&type=template&id=159a8422"
import script from "./FormAbandonConfirmModal.vue?vue&type=script&lang=js"
export * from "./FormAbandonConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FormAbandonConfirmModal.vue"]])

export default __exports__